import Navbar from './navbar/navbar.component';

export { Navbar };
